import http from '@/utils/request'

export async function list(param, callId = null, callArgs = {}) { // org/:id/?expand=formUser,formUser.user
  let url = `/tpl/list`
  if (param.query) { url += param.query }

  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

export async function list2(param, callId = null, callArgs = {}) { // org/:id/?expand=formUser,formUser.user
  let url = `/tpl/list2`
  if (param.query) { url += param.query }

  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'GET'
  })
}

export async function clone(param, callId = null, callArgs = {}) {
  let url = `/tpl/${param.id}/clone`
  if (param.query) {
    url += param.query
  }
  return await http.request({
    callId: callId,
    callArgs: callArgs,
    url: url,
    method: 'POST'
  })
}
